export default {
  buttons: {
    cancel: "ANNULEREN",
    dismiss: "Sluiten",
    minimize: "Minimaliseren",
    unminimize: "Minimaliseren ongedaan maken",
    add_waypoint: "voeg een bestemming toe"
  },
  distance: {
    value: "{distance, number, distance} {unit}"
  },
  send_to_phone: {
    mail: {
      body: "{url}"
    }
  },
  search: {
    title: "Zoeken ",
    placeholder: "Vul een locatie in",
    enter_location: "Vul een locatie in",
    recent_searches: "Recente zoekopdrachten",
    suggestions: "Suggesties",
    help: {
      inactive: "Zoeken "
    }
  },
  filters: {
    more: "Meer filters",
    less: "Minder filters",
    group: {
      more: "Meer",
      less: "Minder"
    },
    amenities: {
      title: "Service en voorzieningen"
    },
    fuels: {
      title: "Brandstoftypen"
    }
  },
  directions: {
    title: "Routeplanner",
    help: {
      add_waypoint: "Routepunt toevoegen",
      reverse: "Route omdraaien",
      sort_waypoint: "Sleep om te herschikken"
    },
    placeholder: {
      origin: "Selecteer startpunt",
      destination: "Vul een locatie in",
      waypoint: "Vul een locatie in"
    },
    route: {
      title: "Route opties",
      avoid_tolls: "Tolwegen vermijden",
      avoid_highways: "Snelwegen vermijden",
      title_corridor: "Afstand van route naar servicestations"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# dag} other {# dagen}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# min}}\
`,
    button: "Zoeken ",
    error: "Er is een probleem ontstaan bij het verwerken van de route. Probeer opnieuw."
  },
  action_panel: {
    back_to_results: "Terug naar Resultaten"
  },
  locations: {
    title: "locaties",
    closed_temporarily: "Tijdelijk gesloten",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} van {place}",
    description: "{visible, select, true {Verbergen} false {Tonen} }"
  },
  info_window: {
    back_to_results: "Terug naar Resultaten",
    title: "Locatiegegevens",
    services: "Service en voorzieningen",
    nearby: "In de buurt",
    directions: "Toevoegen aan routeplanner",
    mobile: {
      telephone: "Tel: "
    },
    opening_hours: {
      title: "Openings- en sluitingstijden",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      available: "Aanwezige brandstoffen en prijzen",
      not_available: "Aanwezige brandstoffen",
      price: "{price, number, fuelPrice}",
      disclaimer: "Alle informatie is zonder garanties; alleen de prijzen aan de pomp zijn geldig.",
      last_updated_on: "Laatst bijgewerkt",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Routeplanner"
  },
  fuels: {
    autogas_lpg: "Autogas (LPG)",
    fuelsave_midgrade_gasoline: "Shell FuelSave Euro 95",
    fuelsave_regular_diesel: "Shell FuelSave Diesel",
    gtl: "Shell GTL",
    lng: "Shell LNG",
    premium_diesel: "Shell V-Power Diesel",
    premium_gasoline: "Shell V-Power"
  },
  amenities: {
    air_and_water: "Lucht",
    atm: "Geldautomaat",
    austrian_highway_sticker: "Oostenrijkse snelwegsticker",
    bakery_shop: "Bakkerij",
    bottled_gas: "Wisselen van BBQ-propaancilinder",
    clubsmart_card: "Club-smartcard",
    credit_card_american_express: "Creditcard - American Express",
    credit_card_diners_club: "Creditcard - Diners",
    credit_card_mastercard: "Creditcard - Mastercard",
    credit_card_visa: "Creditcard - Visa",
    credit_card: "Creditcard",
    czech_highway_sticker: "Tsjechische snelwegsticker",
    disability_assistance: "fuelService",
    euroshell_card: "euroShell Card",
    fleet_card_dkv: "Fleetcard - DKV",
    fleet_card_eni: "Fleetcard - Eni",
    fleet_card_esso: "Fleetcard - Esso",
    fleet_card_general: "Fleetcard",
    fleet_card_uta: "Fleetcard - UTA",
    food_offerings: "Eten aanbod",
    full_service: "Full-service/Bediening",
    guarded_car_park: "Bewaakt parkeerterrein ",
    hgv_lane: "Geschikt voor vrachtwagens ",
    hot_food: "Warm eten",
    hungarian_highway_sticker: "Hongaarse snelwegsticker",
    ido_ticket: "Ido-ticket",
    jet: "Jet Wash",
    maut_terminal: "Maut Terminal",
    parking_lanes: "Parkeerstrook",
    partner_loyalty_accepted: "Loyalty partner geaccepteed",
    pay_at_pump: "Betalen bij de pomp",
    quick_lubes: "Snel smeren",
    self_service: "Self-service",
    service_bay: "Garage",
    shell_card: "euroShell Card",
    shop: "Winkel",
    shower: "Douche",
    slovak_highway_sticker: "Slowaakse snelwegsticker",
    snack_food: "Snacks/Fastfood",
    supermarket_fuel_discount: "Korting op brandstof",
    truck_parking: "Parkeerterrein voor vrachtwagens",
    truckport: "Alleen voor vrachtwagens",
    twenty_four_hour: "24 uur",
    unmanned: "Onbemand",
    vacuum: "Stofzuiger",
    vehicle_identity_system: "Voertuigidentiteitssysteem",
    deli_by_shell: "DeliByShell",
    adblue_truck: "AdBlue voor vrachtwagens",
    adblue_car: "AdBlue voor personenautos",
    adblue_pack: "AdBlue - voorverpakt"
  },
  settings: {
    title: "Instellingen",
    tooltip: "Instellingen",
    distance_units: {
      title: "Afstand",
      miles: "mijlen"
    },
    language: {
      title: "Taal"
    }
  }
}
